import http from '@/utils/http'
import axios from 'axios'
export function login(phone, validateCode) {
  const data = {
    phone,
    validateCode
  }
  return http({
    url: '/bi-api/login',
    method: 'post',
    data
  })
}
export function getIdentifyingCodes(phone) {
  return http({
    //url: '/bi-api/account/getMobileValidateCode',
    url:'/bi-api/getValidateCode?time='+new Date()*1,
    method: 'get',
    params: { phone }
  })
}

export function logout() {
  return http({
    url: '/bi-api/logout',
    method: 'post'
  })
}

export function getUserInfo(username) {
  return http({
    //url: '/user/info',
    url:'/bi-api/auth?t='+new Date()*1,
    method: 'get',
    params: { username }
  })
}
